import React from 'react';
import { Box, keyframes } from '@mui/material';

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const AnimatedCircle = ({ children, sx, ...props }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #0d296a, #0d296a)',
        boxShadow: '0 4px 20px rgba(13, 41, 106, 0.3)',
        animation: `${bounce} 2s infinite`,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default AnimatedCircle;
